'use strict';

/**
 * @classname GetCardToken
 * @classdesc カードトークン取得
 */
export default class GetCardToken {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-order-confirm
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		Multipayment.init(window.const.GMO.SHOP_ID);
		this._cardNoInput = false;
		this._expiredMonthInput = false;
		this._expiredYearInput = false;
		this._securityCodeInput = false;
		const $creditCardNo = $('#credit_card_no');
		const $expiredMonth = $('#expired_month');
		const $expiredYear = $('#expired_year');
		const $securityCode = $('#security_code');
		$creditCardNo.on('blur', () => {
			this._cardNo = $creditCardNo.val();
			this._cardNoInput = (this._cardNo.match(/\d{14,16}/)) ? true: false;
			if (this._cardNoInput) this.checkInput();
		});
		$expiredMonth.on('change', () => {
			this._expiredMonth = $expiredMonth.val();
			this._expiredMonthInput = (this._expiredMonth !== '') ? true: false;
			if (this._expiredMonthInput) this.checkInput();
		});
		$expiredYear.on('change', () => {
			this._expiredYear = $expiredYear.val()
			this._expiredYearInput = (this._expiredYear !== '') ? true: false;
			if (this._expiredYearInput) this.checkInput();
		});
		$securityCode.on('blur', () => {
			this._securityCode = $securityCode.val();
			this._securityCodeInput = (this._securityCode.match(/\d{3,4}/)) ? true: false;
			if (this._securityCodeInput) this.checkInput();
		});
	}


	/**
	 * 入力内容確認
	 *
	 * @memberof GetCardToken
	 * @return undefined
	 */
	checkInput() {
		console.log(`${this.constructor.name}.checkInput`);
		if (this._cardNoInput && this._expiredMonthInput && this._expiredYearInput && this._securityCodeInput) {
			this.sendCardInfo();
		}
	};


	/**
	 * カード情報送信
	 *
	 * @memberof GetCardToken
	 * @return undefined
	 */
	sendCardInfo() {
		console.log(`${this.constructor.name}.sendCardInfo`);
		const cardInfo = {
			cardno: this._cardNo,
			expire: `20${this._expiredYear}${this._expiredMonth}`,
			securitycode: this._securityCode,
			tokennumber: 1
		}
		Multipayment.getToken(cardInfo, setToken);
	};
};
